import Vue from 'vue';
import 'vant/lib/index.css';

import NavBar from 'vant/lib/nav-bar';
import Form from 'vant/lib/form';
import Tag from 'vant/lib/tag';
import Button from 'vant/lib/button';
import Tabbar from 'vant/lib/tabbar';
import TabbarItem from 'vant/lib/tabbar-item';
import Step from 'vant/lib/step';
import Steps from 'vant/lib/steps';
import Toast from 'vant/lib/toast';
import Cell from 'vant/lib/cell';
import CellGroup from 'vant/lib/cell-group';
import Dialog from 'vant/lib/dialog';
import List from 'vant/lib/list';
import PullRefresh from 'vant/lib/pull-refresh';
import Switch from 'vant/lib/switch';
import Search from 'vant/lib/search';
import Field from 'vant/lib/field';
import checkbox from 'vant/lib/checkbox';
import Image from 'vant/lib/image';
import NoticeBar from 'vant/lib/notice-bar';
import ActionSheet from 'vant/lib/action-sheet';
import DropdownMenu from 'vant/lib/dropdown-menu';
import DropdownItem from 'vant/lib/dropdown-item';
import Sidebar from 'vant/lib/sidebar';
import SidebarItem from 'vant/lib/sidebar-item';
import SwipeCell from 'vant/lib/swipe-cell';
import Sticky from 'vant/lib/sticky';

// 按需加载，必须这样做。不然会和element的某些组件冲突！
Vue.use(NavBar);
Vue.use(Form);
Vue.use(Tag);
Vue.use(Button);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Step);
Vue.use(Steps);
Vue.use(Toast);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Dialog);
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Switch);
Vue.use(Search);
Vue.use(Field);
Vue.use(checkbox);
Vue.use(Image);
Vue.use(NoticeBar);
Vue.use(ActionSheet);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Sidebar);
Vue.use(SidebarItem);
Vue.use(SwipeCell);
Vue.use(Sticky);
